export const TEXT_RATING_LEVEL =[
    "Rất tệ",
    "Tệ",
    "Cũng được",
    "Tốt",
    "Rất tốt"
]

export const TEXT_REQUIRE_RATING = "Đánh giá Timi"
export const TURN_FINISHED_RATING = 5